export type AdminAccessMode = 'full' | 'limited';
export type AdminPermissionCode = 'analytics.read' | 'analytics.schema.manage' | 'analytics.sensitive.read';

export interface AdminUser {
  id: string;
  email: string;
  displayName: string;
  accessMode: AdminAccessMode;
  permissions: AdminPermissionCode[];
}

export interface ManagedAdminUser extends AdminUser {
  enabled: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export function hasAdminPermission(user: AdminUser, permission: AdminPermissionCode): boolean {
  return user.accessMode === 'full' || user.permissions.includes(permission);
}
